import React from 'react';
import { Columns } from '@components/Columns';
import {
  StyledBox,
  StyledBoxMobile,
  StyledCloudImageMobile,
  BoxContainer,
  DetailWrapper,
  TagMainTextPairing,
  StyledFlex,
} from './TagTheyAreIt.styles';
import { WeddingParty } from './WeddingParty';
import { MagneticItem } from './MagneticItem';
import { useTranslation } from 'react-i18next';

export const TagTheyAreIt: React.FC<{}> = () => {
  const sectionId = 'Worthy_of_Celebration';
  const { t } = useTranslation('guestList');
  const tags = t('tags');

  const listItemAvatar = [
    // Top Left
    {
      type: 'avatar',
      avatarUrl: 'common/avatars/avatars_photo_avatar-17.jpg',
      sizeVariant: 90,
      resSizeVariant: 100,
      alt: 'Best Woman',
      top: '50px',
      resTop: '340px',
      left: '105px',
      resLeft: '30%',
    },
    {
      type: 'avatar',
      avatarUrl: 'common/avatars/avatars_photo_avatar-3.jpg',
      sizeVariant: 253,
      resSizeVariant: 140,
      top: '25px',
      resTop: '115px',
      left: '230px',
      resLeft: '-20%',
    },
    {
      type: 'avatar',
      avatarUrl: 'common/avatars/avatars_photo_avatar-2.jpg',
      sizeVariant: 136,
      resSizeVariant: 100,
      top: '180px',
      resTop: '0px',
      left: '60px',
      resLeft: '-100%',
    },
    // Top Right
    {
      type: 'avatar',
      avatarUrl: 'common/avatars/avatars_photo_avatar-4.jpg',
      sizeVariant: 220,
      resSizeVariant: 120,
      top: '-70px',
      resTop: '65px',
      left: '645px',
      resLeft: '30%',
    },
    {
      type: 'avatar',
      avatarUrl: 'common/avatars/avatars_photo_avatar-5.jpg',
      sizeVariant: 212,
      resSizeVariant: 110,
      top: '100px',
      resTop: '180px',
      left: '870px',
      resLeft: '58%',
    },
    {
      type: 'avatar',
      avatarUrl: 'common/avatars/avatars_photo_avatar-9.jpg',
      sizeVariant: 142,
      resSizeVariant: 90,
      top: '70px',
      resTop: '225px',
      left: '1100px',
      resLeft: '93%',
    },
    {
      type: 'avatar',
      avatarUrl: 'common/avatars/avatars_photo_avatar-11.jpg',
      sizeVariant: 129,
      resSizeVariant: 90,
      top: '330px',
      resTop: '225px',
      left: '1020px',
      resLeft: '93%',
    },
    // Middle Left
    {
      type: 'avatar',
      avatarUrl: 'common/avatars/avatars_photo_avatar-6.jpg',
      sizeVariant: 117,
      resSizeVariant: 100,
      top: '540px',
      resTop: '0px',
      left: '-10px',
      resLeft: '-100%',
    },
    {
      type: 'avatar',
      avatarUrl: 'common/avatars/avatars_photo_avatar-1.jpg',
      sizeVariant: 220,
      resSizeVariant: 100,
      top: '425px',
      resTop: '0px',
      left: '135px',
      resLeft: '-100%',
    },
    {
      type: 'avatar',
      avatarUrl: 'common/avatars/avatars_photo_avatar-12.jpg',
      sizeVariant: 107,
      resSizeVariant: 100,
      top: '670px',
      resTop: '0px',
      left: '110px',
      resLeft: '-100%',
    },
    // Middle Right
    {
      type: 'avatar',
      avatarUrl: 'common/avatars/avatars_photo_avatar-6.jpg',
      sizeVariant: 117,
      resSizeVariant: 90,
      top: '540px',
      resTop: '225px',
      left: '950px',
      resLeft: '93%',
    },
    {
      type: 'avatar',
      avatarUrl: 'common/avatars/avatars_photo_avatar-40.jpg',
      sizeVariant: 143,
      resSizeVariant: 90,
      top: '520px',
      resTop: '225px',
      left: '1160px',
      resLeft: '93%',
    },
    {
      type: 'avatar',
      avatarUrl: 'common/avatars/avatars_photo_avatar-9.jpg',
      sizeVariant: 203,
      resSizeVariant: 90,
      top: '680px',
      resTop: '225px',
      left: '980px',
      resLeft: '93%',
    },
    // Bottom
    {
      type: 'avatar',
      avatarUrl: 'common/avatars/avatars_photo_avatar-26.jpg',
      sizeVariant: 246,
      resSizeVariant: 100,
      top: '675px',
      resTop: '310px',
      left: '400px',
      resLeft: '70%',
    },
    {
      type: 'avatar',
      avatarUrl: 'common/avatars/avatars_photo_avatar-7.jpg',
      sizeVariant: 171,
      resSizeVariant: 130,
      top: '675px',
      resTop: '250px',
      left: '690px',
      resLeft: '9%',
    },

    {
      type: 'tag',
      avatarUrl: tags.tagFamily,
      sizeVariant: 274,
      resSizeVariant: 100,
      alt: 'Best Woman',
      top: '155px',
      resTop: '340px',
      left: '70px',
      resLeft: '30%',
    },
    {
      type: 'tag',
      avatarUrl: tags.tagOutOfTown,
      sizeVariant: 274,
      resSizeVariant: 100,
      alt: 'Family',
      top: '612px',
      resTop: '0px',
      left: '30px',
      resLeft: '-100%',
    },
    {
      type: 'tag',
      avatarUrl: tags.tagCollegeFriends,
      sizeVariant: 411,
      resSizeVariant: 100,
      alt: 'Wedding Party',
      top: '622px',
      resTop: '0px',
      left: '930px',
      resLeft: '-100%',
    },
    {
      type: 'tag',
      avatarUrl: tags.tagVegans,
      sizeVariant: 274,
      resSizeVariant: 100,
      alt: 'Vegan',
      top: '70px',
      resTop: '0px',
      left: '760px',
      resLeft: '-100%',
    },
    {
      type: 'tag',
      avatarUrl: tags.tagCoworkers,
      sizeVariant: 274,
      resSizeVariant: 100,
      alt: 'Co workers',
      top: '780px',
      resTop: '0px',
      left: '545px',
      resLeft: '-100%',
    },
    {
      type: 'tag',
      avatarUrl: tags.tagWeddingParty,
      sizeVariant: 274,
      resSizeVariant: 100,
      alt: 'College Friends',
      top: '265px',
      resTop: '0px',
      left: '990px',
      resLeft: '-100%',
    },
  ];

  return (
    <BoxContainer paddingTop={[7, 7, 12]} id={sectionId}>
      <WeddingParty />
      <StyledFlex id="Magnetic_Container">
        <StyledBox paddingBottom={[0, 12]}>
          {listItemAvatar.map((avatar, index) => (
            <MagneticItem
              key={index}
              type={avatar.type}
              avatarUrl={avatar.avatarUrl}
              sizeVariant={avatar.sizeVariant}
              top={avatar.top}
              left={avatar.left}
              resTop={avatar.resTop}
              resLeft={avatar.resLeft}
              resSizeVariant={avatar.resSizeVariant}
            />
          ))}
        </StyledBox>
        <StyledBoxMobile paddingBottom={[0, 12]}>
          <StyledCloudImageMobile src="guest-list/tags-art/mobile.png" alt="Tags Art Mobile" width="100%" />
        </StyledBoxMobile>
        <DetailWrapper paddingTop={[0, 10]} paddingBottom={[0, 10]}>
          <Columns>
            <Columns.Column offset="two" width="eight">
              <TagMainTextPairing
                alignment="center"
                eyebrow={tags.eyebrow}
                eyebrowColor="humanaDark4"
                eyebrowVariant="sectionEyeBrow24"
                eyebrowTagName="h2"
                title={tags.title}
                titleColor="neutra6"
                titleVariant="hed72Hero"
                titleTagName="h2"
                body={tags.content}
                bodyVariant="dek20"
                bodyColor="neutra5"
              />
            </Columns.Column>
          </Columns>
        </DetailWrapper>
      </StyledFlex>
    </BoxContainer>
  );
};
